module.exports = { raw: '8.11.3' };



//////////////////
// WEBPACK FOOTER
// ./~/auth0-js/src/version.js
// module id = 388
// module chunks = 0